import { mediaItems } from '@/mocks/home';

const tagColorMap: Record<string, string> = {
  primary: 'bg-primary-500 text-background-50',
  accent: 'bg-accent-500 text-background-50',
  secondary: 'bg-secondary-500 text-background-50',
};

const mediaImages = [
  'https://readdy.ai/api/search-image?query=Abstract%20stylized%20editorial%20illustration%20of%20entertainment%20news%20breaking%20story%20concept%2C%20warm%20dark%20background%20with%20coral%20and%20amber%20accents%2C%20journalistic%20aesthetic%2C%20modern%20clean%20design%2C%20dramatic%20lighting%2C%20entertainment%20industry%20theme%2C%20professional%20newsroom%20vibe%2C%20abstract%20composition%20with%20headline%20elements&width=800&height=500&seq=media-718-01&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Television%20studio%20behind%20the%20scenes%20abstract%20illustration%2C%20warm%20amber%20lighting%2C%20production%20equipment%20silhouettes%2C%20dramatic%20atmosphere%2C%20editorial%20style%2C%20modern%20composition%2C%20entertainment%20industry%20theme%2C%20dark%20warm%20background%20with%20gold%20highlights&width=800&height=500&seq=media-718-02&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Magnifying%20glass%20over%20headlines%20concept%2C%20investigative%20journalism%20theme%2C%20warm%20dark%20background%20with%20coral%20highlights%2C%20abstract%20stylized%2C%20clean%20modern%20design%2C%20entertainment%20scandal%20investigation%20aesthetic%2C%20dramatic%20lighting%2C%20professional%20newsroom%20vibe&width=800&height=500&seq=media-718-03&orientation=landscape',
];

export default function MediaSection() {
  return (
    <section id="media" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">
              媒体爆料
            </h2>
            <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto leading-relaxed">
              独家深扒与现场直击，带你深入事件核心
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
            {mediaItems.map((item, i) => (
              <article
                key={i}
                className="group flex flex-col bg-background-50 rounded-lg border border-background-200/70 overflow-hidden hover:border-accent-200 transition-all duration-300 cursor-pointer"
              >
                <div className="relative w-full aspect-[16/10] overflow-hidden bg-background-200">
                  <img
                    src={mediaImages[i]}
                    alt={item.title}
                    title={`黑料718 - ${item.title}`}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                  <span className={`absolute top-3 left-3 text-xs font-medium px-2.5 py-1 rounded-full ${tagColorMap[item.tagColor]} whitespace-nowrap`}>
                    {item.tag}
                  </span>
                </div>

                <div className="flex flex-col flex-grow p-4 md:p-5">
                  <h3 className="text-base font-semibold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors duration-200">
                    {item.title}
                  </h3>
                  <p className="text-sm text-foreground-500 leading-relaxed mb-4 line-clamp-3 flex-grow">
                    {item.desc}
                  </p>
                  <div className="flex items-center justify-between text-xs text-foreground-400">
                    <span className="flex items-center gap-1">
                      <i className="ri-eye-line"></i>
                      {item.views}
                    </span>
                    <span>{item.time}</span>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}